import React, {useContext} from "react";
import {LanguageContext} from "../../App";
import classes from "../../styles/component_styles/services.module.scss";
import image from "../../images/services/WaterDamageRestoration.webp";
import {FaHouseDamage} from "react-icons/fa";
import {Col, Container, Row} from "react-bootstrap";
import {Helmet} from "react-helmet";

function WaterDamageRestorationPage() {

    const languageContext = useContext(LanguageContext);

    return(
        <>

            <Helmet>
                <title>Water Damaging Restoration Services in Charlotte NC</title>
                <meta
                    name="description"
                    content="Discover expert water damage restoration services in Charlotte NC. Our skilled team ensures quality restoration for your property's water-related issues."
                />
            </Helmet>

            <div className={classes.start_image}>
                <h1 className={classes.start_message}><FaHouseDamage className={classes.servicesIcon}/> {languageContext.services.WaterDamageRestorationPage.title}</h1>
                <p className={classes.darkText}>{languageContext.services.WaterDamageRestorationPage.description}</p>
            </div>

            <Container>
                <Row>
                    <Col xl={8} lg={8} md={6} sm={12} xs={12}>
                        <p className={classes.description}>
                            {languageContext.services.WaterDamageRestorationPage.text1}
                            <br/><br/>
                            <span>{languageContext.services.WaterDamageRestorationPage.text2}</span>
                            <br/>
                            {languageContext.services.WaterDamageRestorationPage.text3}
                            <br/><br/>
                            <span>{languageContext.services.WaterDamageRestorationPage.text4}</span>
                            <br/>
                            {languageContext.services.WaterDamageRestorationPage.text5}
                            <br/><br/>
                            <span>{languageContext.services.WaterDamageRestorationPage.text6}</span>
                            <br/>
                            {languageContext.services.WaterDamageRestorationPage.text7}
                            <br/><br/>
                            <span>{languageContext.services.WaterDamageRestorationPage.text8}</span>
                            <br/>
                            {languageContext.services.WaterDamageRestorationPage.text9}
                        </p>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12} xs={12}>
                        <img src={image} className={classes.image}/>
                    </Col>
                </Row>
            </Container>
        </>
    );

}

export default WaterDamageRestorationPage;